module.exports = __webpack_public_path__ + "img/locked.53ce00bb.svg";